import {logger} from 'lib/logger.js';

const sendCookieData = async (data) => {
  const urlPath = '/api/data-cookies';

  logger.log("[setDataPage]data in", JSON.stringify(data));

  try {
    const response = await fetch(urlPath,{
      method: 'POST',
      body: JSON.stringify(data),
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      }
    });

    if (!response.ok) {
      return await response.json();
    }

    return {
      code: 200,
      status: 'success',
      content: '',
    };
  } catch (error) {
    // Maneja cualquier error que ocurra durante la solicitud o procesamiento
    console.error('Error al obtener la pagina:', error);
    return {
      code: 500,
      status: 'Internal Server Error',
      content: error.message || 'Error desconocido',
    };
  }
};

export default sendCookieData;